import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.regexp.replace.js";
import { MigrationError } from '@nerdwallet/structured-content-core/migrations';
import { WPPOSTLIST } from '../../../types'; // migration follows refactor of WpPostList to request data from query0 instead of wp api directly
// eslint-disable-next-line camelcase

export default function migrateWpPostListFrom_1_0_0_to_2_0_0(_ref) {
  var type = _ref.type,
      version = _ref.version,
      props = _ref.props;

  if (version !== '1.0.0') {
    throw new MigrationError("".concat(WPPOSTLIST, " v2.0.0 migrator should only operate on ").concat(WPPOSTLIST, " v1.0.0 nodes, got: v").concat(version));
  }

  var _props$query = props.query,
      categories = _props$query.categories,
      include = _props$query.include,
      exclude = _props$query.exclude,
      per_page = _props$query.per_page,
      post_types = _props$query.post_types,
      author = _props$query.author; // convert prop names and values from wp-api-service vocabulary to query0 schema vocabulary

  var query = {
    authorIds: author,
    categoryIdentifiers: categories,
    // convert post_types to PostTypeEnum values (query0 type)
    contentTypes: post_types === null || post_types === void 0 ? void 0 : post_types.map(function (postType) {
      return postType.replace('nw_', '').replace(/-/g, '_').toUpperCase();
    }),
    include: include,
    exclude: exclude,
    perPage: per_page
  };
  return {
    type: type,
    version: '2.0.0',
    props: _objectSpread(_objectSpread({}, props), {}, {
      query: query
    })
  };
}